import { Theme, css } from '@emotion/react';

export const autocompleteRoot = ({ colors }: Theme) => css`
  .MuiAutocomplete-root {
    height: 100%;
    width: 100%;
  }

  .MuiAutocomplete-inputRoot {
    padding: 0 !important;
    & .MuiAutocomplete-input {
      padding: 20px 12px 7px !important;
    }
  }

  .MuiAutocomplete-listbox {
    & .MuiAutocomplete-option[data-focus='true'] {
      background-color: ${colors.bgPrimaryLighter};
    }
  }
`;

export const autocompleteInputBase = ({ colors }: Theme) => css`
  .MuiAutocomplete-inputRoot {
    background-color: ${colors.bgDefault};
    height: 100%;
    width: 100%;

    & .MuiInputBase-root {
      height: 100%;
    }
  }
`;
